import { ChunkQueue } from "./chunkQueue";
import { webSocketManager } from "./webSocket";

const SEND_INTERVAL_MS = 1000; // 1 second

export class ChunkProcessor {
  private chunkQueue: ChunkQueue;
  private isSocketConnected: boolean = false;
  private isRecordingStopped: boolean = false;
  private endMessageSent: boolean = false;
  private sendIntervalId: number | null = null;
  private onAllChunksSent?: () => void;
  private onBackupSaved?: (blob: Blob) => void;

  constructor(chunkQueue: ChunkQueue) {
    this.chunkQueue = chunkQueue;
  }

  startChunkProcessing(): void {
    if (this.sendIntervalId) return; // prevent multiple intervals

    this.sendIntervalId = setInterval(() => {
      if (!this.isSocketConnected && this.chunkQueue.getQueueLength() > 0) {
        console.warn(
          `Socket not connected, waiting... Queue size: ${this.chunkQueue.getQueueLength()}`
        );
        if (this.isRecordingStopped) {
          this.saveBackupToDesktop();
        }
        return;
      }

      if (this.chunkQueue.getQueueLength() > 0) {
        const chunk = this.chunkQueue.getNextChunk();
        if (chunk) {
          const success = webSocketManager.sendChunk(chunk);
          if (success) {
            // console.log(`Chunk sent SUCCESSFULLY. Size: ${chunk.byteLength}`);
          } else {
            console.error("Chunk sending FAILED");
          }
        }
      }

      this.checkIfAllChunksSent();
    }, SEND_INTERVAL_MS);
  }

  stopChunkProcessing(): void {
    if (this.sendIntervalId) {
      clearInterval(this.sendIntervalId);
      this.sendIntervalId = null;
    }
  }

  private checkIfAllChunksSent(): void {
    if (
      this.isRecordingStopped &&
      this.chunkQueue.getQueueLength() === 0 &&
      !this.endMessageSent
    ) {
      console.log(
        "All chunks sent and recording stopped. Sending END message."
      );
      this.endMessageSent = true;
      this.stopChunkProcessing();

      setTimeout(() => {
        webSocketManager.sendEndMessage();
        this.onAllChunksSent?.();
      }, 2000);
    }

    if (
      !this.isSocketConnected &&
      this.chunkQueue.getQueueLength() > 0 &&
      this.isRecordingStopped
    ) {
      console.log("No socket connection on stop. Saving backup.");
      this.saveBackupToDesktop();
    }
  }

  private saveBackupToDesktop(): void {
    this.stopChunkProcessing();
    const blob = this.chunkQueue.getBackupBlob();
    this.onBackupSaved?.(blob);
  }

  setSocketStatus(status: boolean): void {
    this.isSocketConnected = status;
  }

  setRecordingStopped(status: boolean): void {
    this.isRecordingStopped = status;
  }

  getSocketStatus(): boolean {
    return this.isSocketConnected;
  }

  setOnAllChunksSent(callback: () => void): void {
    this.onAllChunksSent = callback;
  }

  setOnBackupSaved(callback: (blob: Blob) => void): void {
    this.onBackupSaved = callback;
  }

  reset(): void {
    this.stopChunkProcessing();
    this.isRecordingStopped = false;
    this.endMessageSent = false;
    this.chunkQueue.clear();
  }
}
